import { Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import type { Product } from "../productDetails/ProductDetails";
import ProductDetails from "../productDetails/ProductDetails";

interface Props {
  readonly productDetails: Product | undefined;
  readonly providerId?: string;
  readonly detailsPosition?: "bottom" | "right";
}

const ProductName: FC<PropsWithChildren<Props>> = ({ children, productDetails, providerId, detailsPosition }) => {
  if (detailsPosition === "right") {
    return (
      <Stack direction="row">
        {children}
        <ProductDetails product={productDetails} providerId={providerId} />
      </Stack>
    );
  }
  return (
    <Stack direction="column">
      {children}
      <Stack direction="row">
        <ProductDetails product={productDetails} providerId={providerId} />
      </Stack>
    </Stack>
  );
};

export default ProductName;
